<template>
    <div>
        <table class="table">
            <thead>
            <tr>
                <th>№</th>
                <th>Date</th>
                <th>Title</th>
                <th>Description</th>
                <th>Order</th>
                <th class="center"></th>
            </tr>
            </thead>
            <tbody>
                <tr v-for="(tutorial, index) in tutorials" :key="tutorial.order">
                    <td>
                        <span>
                            <a>{{ index + 1 }}</a>
                        </span>
                    </td>
                    <td>
                        <span>
                            <a>{{ getPublishDate(tutorial.created_at) }}</a>
                        </span>
                    </td>
                    <td>
                        <span>{{ tutorial.title }}</span>
                    </td>
                    <td>
                        <span>{{ tutorial.description }}</span>
                    </td>
                     <td>
                         <div class="d-flex flex-column">
                            <ion-icon name="chevron-up-outline" @click="increaseTutorialPosition(index)"></ion-icon>
                            <ion-icon name="chevron-down-outline" @click="decreaseTutorialPosition(index)"></ion-icon>
                         </div>
                    </td>

                    <td class="center">
                        <admin-actions-dropdown>
                            <b-dropdown-item :href="route('platform-menu.tutorials.edit', tutorial.id)">
                                Edit
                            </b-dropdown-item>
                            <b-dropdown-item @click="changeTutorialStatus(tutorial.id, tutorial.status)">
                                {{ tutorial.status ? 'Make Inactive' : 'Make Active' }}
                            </b-dropdown-item>
                            <app-icon-button
                                :link="route('platform-menu.tutorials.destroy', tutorial.id)"
                                :confirm-message="`Are you sure you want to delete tutorial ${ tutorial.title } ?`"
                                link-method="DELETE">
                                <b-dropdown-item>
                                    Delete
                                </b-dropdown-item>
                            </app-icon-button>
                        </admin-actions-dropdown>
                    </td>
                </tr>

                <tr v-if="tutorials.length === 0">
                    <td class="table-empty" colspan="5">No tutorials. C'mon, add some !</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    props: {
        tutorialsList: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            tutorials: {},
            renderingKey: 1
        }
    },

    created() {
        this.renderTutorials();
    },

    methods: {
        renderTutorials() {
            this.tutorials = this.tutorialsList.length > 0
                ? JSON.parse(this.tutorialsList)
                : {};
        },

        getPublishDate(timestamp) {
            let date = new Date(timestamp);
            return `${date.getDate()}/${date.getMonth()+1}/${date.getFullYear()}`;
        },

        changeTutorialStatus(id, status) {
            axios.post(route('platform-menu.tutorials.change-status'), {'id': id, 'status': status})
                .then(() => {
                    let newStatus = !status;
                    this.updateTutorialStatus(id, newStatus);
                });
        },

        updateTutorialStatus(id, newStatus) {
            let targetTutorial = this.tutorials.find(tutorial => tutorial.id === id);
            targetTutorial.status = newStatus;
            this.generateChangedStatusNotification(newStatus);
        },

        generateChangedStatusNotification(status) {
            this.$notifications.success(`Tutorial status has been successfully updated to ${ status ? 'Active' : 'Inactive' }`);
        },

        increaseTutorialPosition(tutorialIndex) {
            if(tutorialIndex > 0) {
                let targetIndex = tutorialIndex;
                let upperIndex = tutorialIndex - 1;

                this.handleOrderChangeAndStore(targetIndex, upperIndex);
            }
        },

        decreaseTutorialPosition(tutorialIndex) {
            if(tutorialIndex < this.tutorials.length) {
                let targetIndex = tutorialIndex;
                let lowerIndex = tutorialIndex + 1;

                this.handleOrderChangeAndStore(targetIndex, lowerIndex);
            }
        },

        handleOrderChangeAndStore(targetIndex, dependentIndex) {
            let currentTutorialId = this.tutorials[targetIndex].id;
            let dependentTutorialId = this.tutorials[dependentIndex].id;

            this.handleOrderChangeInView(targetIndex, dependentIndex);
            this.storeOrderChange(currentTutorialId, dependentTutorialId);
        },

        handleOrderChangeInView(target, dependent) {
            this.swapTutorials(target, dependent);

            let target_order_number = this.tutorials[target].order;
            let dependent_order_number = this.tutorials[dependent].order;

            this.tutorials[target].order = dependent_order_number;
            this.tutorials[dependent].order = target_order_number;

        },

        swapTutorials(target, dependent) {
            [this.tutorials[target], this.tutorials[dependent]] = [this.tutorials[dependent], this.tutorials[target]];
            this.renderingKey++;
        },

        storeOrderChange(currentTutorialId, dependentTutorialId) {
             axios.post(route('platform-menu.tutorials.change-order'), {
                        'target_id': currentTutorialId,
                        'dependent_id': dependentTutorialId
                    })
        }
    },
}
</script>
